import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {TrophyData} from "../../interfaces/trophy-data";
import {TrophyRepositoryService} from "../../services/trophy-repository.service";
import {GameTrophyStatus} from "../../enums/game-trophy-status";

@Component({
  selector: 'brt-trophy-icon',
  templateUrl: './trophy-icon.component.html',
  styleUrls: ['./trophy-icon.component.scss']
})
export class TrophyIconComponent implements OnInit {
  @Input('trophy') set setTrophy(value: TrophyData) {
    this.trophy = value;


  }

  @Input('completed') isCompleted = false;
  trophy!: TrophyData;

  trophyIconPath = "";
  backgroundSrc = "";

  constructor(private trophyRepositoryService: TrophyRepositoryService) {
  }

  ngOnInit() {
    this.trophyIconPath = this.trophyRepositoryService.getTrophyIcon(this.trophy, this.isCompleted);
    const trophyLevel = this.trophyRepositoryService.getTrophyLevel(this.trophy);
    this.backgroundSrc = this.trophyRepositoryService.getTrophyBackgroundSrcByLevel(trophyLevel);
  }

  protected readonly GameTrophyStatus = GameTrophyStatus;
}
